import type { LegalFeatureConfig } from '../../../types/insurances/LegalFeatureConfig';

export const legal: LegalFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
};
